$shm_hitalama_taskmanager_card $mol_view
	task? null
	title? \
	priority? \normal
	created_at_label \
	previous_enabled false
	next_enabled false
	hovered? false
	plugins /
		<= Hovered $shm_hitalama_hovered
			hovered? <=> hovered? false
	auto /
		<= focus_auto null
	attr *
		^
		shm_hitalama_taskmanager_priority <= priority
		shm_hitalama_taskmanager_card_hovered <= hovered
	sub /
		<= Header $mol_view
			sub /
				<= Date $mol_view
					sub /
						<= created_at_label \
		<= Body $mol_view
			sub /
				<= Left $mol_view
					sub /
						<= Priority $shm_hitalama_taskmanager_priority
							hint \Priority
							value? <=> priority? \normal
						<= Move_left $mol_button_minor
							hint \Move left
							enabled <= previous_enabled
							click? <=> move_left? null
							sub /
								<= Move_left_icon $mol_icon_chevron_left
				<= Title $shm_hitalama_textarea
					value? <=> title? \
					hint \
				<= Right $mol_view
					sub /
						<= Delete $mol_pick
							align \center
							hint \Delete task
							trigger_content /
								<= Delete_icon $mol_icon_trash_can
							bubble_content /
								<= Delete_confirm $mol_button_major
									title \Удалить
									click? <=> delete? null
						<= Move_right $mol_button_minor
							hint \Move right
							enabled <= next_enabled
							click? <=> move_right? null
							sub /
								<= Move_right_icon $mol_icon_chevron_right
